import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapsible"
export default class extends Controller {
  static targets = [
    'caret',
    'body'
  ]

  connect() {
    this.isOpen = false;
    if (this.element.getAttribute("data-auto-open") == "true") {
      this.open();
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.bodyTarget.classList.remove("h-0");
    this.caretTarget.classList.add("rotate-90");
    this.isOpen = true;
  }

  close() {
    this.bodyTarget.classList.add("h-0");
    this.caretTarget.classList.remove("rotate-90");
    this.isOpen = false;
  }
}
